import { useRoute } from "vue-router";
import { computed } from "vue";

// The optional locale param can be used to override the locale in the route param
export function useRouteLocale(locale?: string | null) {
   const $route = useRoute();

   // example if locale exists: "/en-gb" (note there is no trailing slash)
   const localePath = computed(() => {
      const localeId = locale || $route.params?.locale;
      return localeId ? `/${localeId}` : "";
   });

   return { localePath };
}
